import { User } from "../../../types/user/user";
import { UserDto } from "../../../types/user/user-dto";
import { convertCompanyDtoToCompany } from "./company-convertor";
import {convertUserType} from "./user-type-converter";

export const convertUserDtoToUser = (userDto: UserDto): User => {
  return {
    id: userDto.id,
    username: userDto.username,
    name: userDto.name,
    phone: userDto.phone,
    birth: userDto.birth,
    role: userDto.role,
    clients: userDto.clients.map((client) =>
      convertCompanyDtoToCompany(client)
    ),
    agencies: userDto.agencies.map((agency) =>
      convertCompanyDtoToCompany(agency)
    ),
    company: convertCompanyDtoToCompany(userDto.company),
    status: userDto.status,
    parkinglot: userDto.parkinglot,
    appViewMode: userDto.appViewMode,
    mobileDevice: userDto.mobileDevice,
    scheduleAlias: userDto.scheduleAlias,
    hasAuthorityToModifyOrder: userDto.hasAuthorityToModifyOrder,
    userType: convertUserType(userDto.userType),
  };
};
